var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMultiplayer = function SvgIconMultiplayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 38 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 16c-.783 0-1.41.052-1.94.13C21.855 16.454 20 18.699 20 21a1 1 0 1 1-2 0c0-2.594 1.627-5.14 3.964-6.284A6.999 6.999 0 0 1 26 2c3.867 0 7 3.134 7 7a7 7 0 0 1-2.952 5.716C32.374 15.86 34 18.406 34 21a1 1 0 1 1-2 0c0-2.302-1.843-4.547-4.048-4.87A13.5 13.5 0 0 0 26 16m0-2c-2.759 0-5-2.24-5-5 0-2.762 2.241-5 5-5s5 2.238 5 5c0 2.76-2.241 5-5 5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 21c-.783 0-1.41.052-1.94.13C7.855 21.454 6 23.699 6 26a1 1 0 1 1-2 0c0-2.594 1.627-5.14 3.964-6.284A6.999 6.999 0 0 1 12 7c3.867 0 7 3.133 7 7a7 7 0 0 1-2.952 5.716C18.374 20.86 20 23.406 20 26a1 1 0 1 1-2 0c0-2.302-1.843-4.547-4.048-4.87A13.5 13.5 0 0 0 12 21m0-2c-2.759 0-5-2.24-5-5 0-2.762 2.241-5 5-5s5 2.238 5 5c0 2.76-2.241 5-5 5",
    clipRule: "evenodd"
  })));
};
export default SvgIconMultiplayer;